import { render, staticRenderFns } from "./OutReachHeading.vue?vue&type=template&id=1c9ebc10&scoped=true&"
import script from "./OutReachHeading.vue?vue&type=script&lang=js&"
export * from "./OutReachHeading.vue?vue&type=script&lang=js&"
import style0 from "./OutReachHeading.vue?vue&type=style&index=0&id=1c9ebc10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9ebc10",
  null
  
)

export default component.exports